// video
var VideoComponent = (function VideoComponent() {
    let videoContainers = document.querySelectorAll('.video-container');

    function attachEvents() {
        videoContainers && videoContainers.forEach(videoContainer => {
            let iframe = videoContainer.querySelector('.video iframe');
            if (!iframe) return;

            // Only use Vimeo player for non-YouTube containers
            if (videoContainer.classList.contains('youtube-video-container')) return;
            if (typeof Vimeo === 'undefined') return;

            let player = new Vimeo.Player(iframe);

            videoContainer.querySelector('.video-thumb').addEventListener("click", function() {
                this.classList.add('hide');
                player.setVolume(0);
				player.play();
            })
        })
    }

    attachEvents();
})();
